<template>
  <div>
    <my-breadcrumb :items="pagination"></my-breadcrumb>
    <div class="forum-container">
      <div class="aalign-end aspace-between">
        <div class="aalign-start">
          <my-button class="ml-2" v-if="$route.params.section" @click="goToForum">
            Liat Forum Pelajaran "{{ section.subject }}"
          </my-button>
          <my-button class="ml-2" v-else-if="section.id" @click="goToClassForum">
            << Kembali ke Forum Sub Bab "{{ section.name }}"
          </my-button>
        </div>

        <div>
          <my-button
            class="ml-2"
            type="fill-yellow"
            @click="addModal = !addModal"
          >
            Yuk Tanya <fa-icon icon="question-circle" class="ml-1"></fa-icon>
          </my-button>
        </div>
      </div>
      <!-- <p class="text-right">
        <button
          class="e-button e-button--small bg-color2 color-white mt-3"
          @click="addModal = !addModal"
        ></button>
      </p> -->

      <div class="forum-content pd-22 mt-4">
        <!-- <h3 class="color2">Forum Diskusi</h3> Dasar - Dasar Trigonometri -->
        <h3 class="mrb-0">
          Forum Diskusi
        </h3>
        <div class="discussions">
          <div class="discussion text-center" style="display: block;">
            <div class="discussion__comments-count" v-if="loadingNew && newCount > 0">
              <b-spinner small label="Loading"></b-spinner>
            </div>
            <div class="discussion__comments-count" style="cursor: pointer;" v-else-if="newCount > 0" @click="loadNew">
              {{ newCount}} New Forum(s)
            </div>
          </div>
          <div
            class="discussion"
            v-for="(item, i) in forums"
            :key="i"
          >
            <div class="discussion__left">
              <img src="/img/avatars/user-avatar4.png" alt="avatar" />
            </div>

            <div class="discussion__middle">
              <div class="aspace-between aalign-start w-100">
                <div>
                  <h4 class="color-1 mb-0">{{ item.title }}</h4>
                  <div class="flex aalign-center">
                    <router-link to="#" class="discussion__username">
                      {{ item.user_name }}
                    </router-link>
                    <div class="discussion__dot"></div>
                    <span class="discussion__time">
                      {{ $helpers.formatDateTimeID(item.created_at) }}
                    </span>
                    <!-- <div class="discussion__dot"></div>
                    <router-link to="#" class="discussion__username">
                      Hide this Thread
                    </router-link> -->
                  </div>
                </div>
                <!-- <div class="aalign-center">
                  <span :id="'tooltip-target-' + i">
                    <fa-icon icon="trash-alt" class="comment-action mt-2 mr-3 ml-3"></fa-icon>
                  </span>
                  <b-tooltip :target="'tooltip-target-' + i" triggers="hover">
                    Delete This Comment
                  </b-tooltip>

                  <span :id="'tooltip-target-r' + i">
                    <fa-icon icon="flag" class="comment-action mt-2"></fa-icon>
                  </span>
                  <b-tooltip :target="'tooltip-target-r' + i" triggers="hover">
                    Report
                  </b-tooltip>
                </div> -->
              </div>

              <p class="forum_p mt-2">
                <div 
                  v-if="item.is_latex"
                  v-katex="{expression: item.content ? item.content : ' ', options: { macros: {' ': '\\space '} }}"
                ></div>
                <div v-else v-html="item.content"></div>
              </p>

              <p class="forum_p mt-2" v-if="item.images.length > 0">
                <img class="mr-2" width="100" :src="itm.url" v-for="(itm, idx) in item.images">
              </p>

              <p class="forum_p mt-2" v-if="item.files.length > 0">
                <span v-for="(itm, idx) in item.files"> 
                  <a :href="itm.url" target="_blank">{{itm.filename}}</a>
                  <br>
                </span>
              </p>

              <router-link
                :to="$route.params.section ? '/class/'+section.id+'/forum/' + item.id : '/forum/' + item.id"
                class="discussion__comments-count"
              >
                {{ item.comments }} Comments
              </router-link>
            </div>

            <!-- <div class="discussion__right">
              <my-button class="ml-5 mb-5" type="teal">
                <fa-icon class="mr-1" icon="pencil-alt"></fa-icon>
                Jawab
              </my-button>
            </div> -->
          </div>
        </div>

        <div class="text-center mt-4" v-if="loadMore && loading">
          <my-button>
            <b-spinner small label="Loading"></b-spinner>
          </my-button>
        </div>
        <div class="text-center mt-4" v-else-if="loadMore" @click="getForum">
          <my-button>
            Load More
          </my-button>
        </div>
      </div>
    </div>
    <b-modal
      id="add-modal"
      v-model="addModal"
      hide-header
      hide-footer
      centered=""
    >
      <div class="modal-cross">
        <img src="/img/icons/close.svg" alt="" @click="addModal = false" />
      </div>
      <h3 class="text-center mt-3">
        Tuliskan Pertanyaan Kamu
      </h3>

      <div class="my-form my-form--in-modal">
        <b-form-group label="Pertanyaan untuk">
          <b-form-radio v-model="newForum.section" name="some-radios" value="1">
            Pertanyaan untuk Sub Bab "{{ section.name }}"
          </b-form-radio>
          <b-form-radio v-model="newForum.section" name="some-radios" value="0">
            Pertanyaan untuk Pelajaran "{{ section.subject }}"
          </b-form-radio>
        </b-form-group>

        <b-form-group label="Judul Pertanyaan" class="mt-4">
          <b-form-input
            placeholder="Title"
            v-model="newForum.title" 
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Isi Pertanyaan" class="mt-4">
          <b-textarea
            v-model="newForum.content"
            id="pertanyaan"
            rows="5"
            placeholder="Type your question..."
          ></b-textarea>
        </b-form-group>

        <b-form-group label="Gunakan Latex" class="mt-4">
          <b-form-checkbox v-model="newForum.is_latex" name="check-button" switch>
            <b>{{ newForum.is_latex ? 'Iya' : 'Tidak' }}</b>
          </b-form-checkbox>
        </b-form-group>

        <math-and-symbol
          v-model="newForum.latexCode"
          @add="addLatex($event)" 
          @batal="newForum.is_latex = false" 
          v-if="newForum.is_latex"
        ></math-and-symbol>

        <div class="added-image mt-2 mr-2" style="width: 100px;" v-for="(item, idx) in newForum.images" :key="'img-'+idx">
          <img width="100" :src="item.link" alt="" />
          <div class="added-image__remove" @click="removeImg(idx)">
            <img src="/img/icons/remove-small.svg" alt="" class="mr-1" />
            <span>Remove</span>
          </div>
        </div>
        <br />
        <br>

        <b-button size="sm" variant="info" @click="$refs.uploadimage.click()">
          <fa-icon icon="upload" class="mr-1"></fa-icon>
          Upload Image
        </b-button>
        <input type="file" accept="image/*" ref="uploadimage" style="display: none" @change="addImg">
        <br />
        <br />

        <ul v-if="newForum.files.length > 0">
          <li v-for="(item, idx) in newForum.files"  :key="'files-'+idx">
            {{ item.filename }} 
            <b-button size="sm" variant="danger" @click="removeFile(idx)">
              <img src="/img/icons/remove-small.svg" alt="" class="mr-1" />
              <span>Remove</span>
            </b-button>
          </li>
        </ul>
        <b-button size="sm" variant="info" @click="$refs.uploadfile.click()">
          <fa-icon icon="upload" class="mr-1"></fa-icon>
          Upload File
        </b-button>
        <input type="file" accept="application/pdf" ref="uploadfile" style="display: none" @change="addFile">
        <br />

        <my-button type="fill-yellow" block class="mt-4 mb-5" v-if="loading">
          <b-spinner small label="Loading"></b-spinner>
        </my-button>
        <my-button type="fill-yellow" block class="mt-4 mb-5" @click="createForum" v-else>
          Submit
        </my-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import { DB } from '@/helpers/fireinit';

export default {
  data() {
    return {
      forums: [],
      newForum: {
        section: 1,
        is_latex: false,
        title: "",
        content: "",
        latexCode: "", 
        images: [], 
        files: []
      },
      level: [], 
      class: [], 
      subject: [],
      level_id: 0,
      class_id: 0,
      subject_id: 0,
      newCount: 0,
      added: false,
      addModal: false, 
      loading: false, 
      loadingNew: false,
      loadMore: false, 
      limit: 10, 
      offset: 0
    };
  },
  props: {
    collapsed: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN, 
      section: types.SECTION
    }),
    pagination() {
      var data = [
        {
          text: this.section.level,
          url: '#'
        },
        {
          text: this.section.class + " "+ this.section.major ? this.section.class : "",
          url: '#'
        },
        {
          text: this.section.subject,
          url: '#'
        },
        {
          text: this.section.curriculum,
          url: '#'
        },
        {
          text: this.section.chapter,
          url: '#'
        },{
          text: this.section.name,
          url: '#'
        }
      ]

      return data
    }
  },
  watch: {
    $route: function(val) {
      this.offset = 0;
      this.setupPage()
    }
  },
  mounted() {
    if(this.isLoggedIn) {
      if(this.$route.params.section && this.$route.params.section != this.section.id) {
        this.$router.push('/class/' + this.$route.params.section)
      } else if(!this.$route.params.section && !this.section.id) {
        this.$router.push("/no-subject");
      } else {
        this.setupPage()
      }
    } else {
      var link = "/login"
      if(this.$route.params.section) {
        link += "?section=" + this.$route.params.section
      }
      this.$router.push(link);
    }
  }, 
  methods: {
    ...mapActions({
      forumSectionList: types.FORUM_SECTION_LIST,
      forumCreate: types.FORUM_CREATE, 
      setOverlay: types.SET_OVERLAY
    }),
    setupPage() {
      this.setOverlay(true);
      this.getForum()
      var that = this
      var d = new Date()
      DB.ref('forum').off()
      DB.ref('forum').orderByChild("created_at").startAt(d.toISOString()).on("child_added", function(snapshot) {
        var newForum = snapshot.val();
        if(that.$route.params.section) {
          if(newForum.target_id == that.section.id) {
            that.newCount++
            that.newForumNotif()
          }
        } else if(that.section.subject_id) {
          if(newForum.subject_id == that.section.subject_id) {
            that.newCount++
            that.newForumNotif()
          }
        }
      });
    },
    loadNew() {
      this.offset = 0
      this.getForum()
    },
    newForumNotif() {
      if(this.added) {
        this.added = false;
      } else {
        this.$bvToast.toast('Ada forum baru', {
          title: 'New Forum',
          autoHideDelay: 3000, 
          toaster: 'b-toaster-top-right',
          variant: 'success'
        })
      }
    },
    getForum() {
      if(this.offset == 0) {
        this.loadingNew = true
      }
      this.loading = true
      var payload = {
        params: { 
          limit: this.limit, 
          offset: this.offset
        }
      }

      if(this.$route.params.section) {
        payload.params.type = 'section'
        payload.params.id = this.section.id
      } else if(this.section.subject_id) {
        payload.params.subject = this.section.subject_id
      }

      this.forumSectionList(payload)
      .then((response) => {
        this.setOverlay(false);
        this.loading = false
        if(this.offset == 0) {
          this.loadingNew = false
          this.newCount = 0
          this.forums = []
        }

        for (var i = 0; i < response.length; i++) {
          this.forums.push(response[i])
        }

        if(response.length < this.limit) {
          this.loadMore = false
        } else {
          this.loadMore = true
        }

        this.offset = this.forums.length
      })
      .catch((error) => {
        this.setOverlay(false);
        this.loading = false
        this.loadingNew = false
        this.$bvToast.toast('Gagal memuat daftar pertanyaan', {
          title: 'Success',
          autoHideDelay: 3000, 
          toaster: 'b-toaster-top-center',
          variant: 'danger'
        })
      });
    },
    createForum() {
      if(this.newForum.title && this.newForum.content) {
        this.loading = true
        this.added = true

        let newFormData = new FormData();
        newFormData.append("subject_id", this.section.subject_id);
        newFormData.append("title", this.newForum.title);
        newFormData.append("content", this.newForum.content);
        newFormData.append("is_latex", this.newForum.is_latex ? 1 : 0);

        if(this.newForum.section == '1') {
          newFormData.append("id", this.section.id);
          newFormData.append("type", 'section');
        }

        if(this.newForum.images.length > 0) {
          var images = []
          for (var i = 0; i < this.newForum.images.length; i++) {
            images.push('image' + i)
            newFormData.append('image' + i, this.newForum.images[i].file);
          }
          newFormData.append('images', images);
        }

        if(this.newForum.files.length > 0) {
          var files = []
          for (var i = 0; i < this.newForum.files.length; i++) {
            files.push('file' + i)
            newFormData.append('file' + i, this.newForum.files[i].file);
          }
          newFormData.append('files', files);
        }

        this.forumCreate(newFormData)
        .then((response) => {
          this.loading = false
          this.addModal = false
          this.$bvToast.toast('Pertanyaan berhasil disimpan', {
            title: 'Success',
            autoHideDelay: 3000, 
            toaster: 'b-toaster-top-center',
            variant: 'success'
          })

          this.offset = 0
          this.getForum()
        })
        .catch((error) => {
          this.loading = false
          this.added = false
          this.$bvToast.toast('Pertanyaan gagal disimpan', {
            title: 'Success',
            autoHideDelay: 3000, 
            toaster: 'b-toaster-top-center',
            variant: 'danger'
          })
        });
      } else {
        this.$bvToast.toast('Judul dan isi pertanyaan tidak boleh kosong', {
          title: 'Empty Data',
          autoHideDelay: 3000, 
          toaster: 'b-toaster-top-center',
          variant: 'warning'
        })
      }
    },
    addLatex(data) {
      this.newForum.content += data;
      this.newForum.latexCode = "";
    }, 
    addImg() {
      var fileData = event.target.files[0]
      var link = URL.createObjectURL(fileData)

      this.newForum.images.push({
        file: fileData, 
        link: link
      })
    },
    removeImg(index) {
      this.newForum.images.splice(index, 1)
    },
    addFile() {
      var fileData = event.target.files[0]
      var filename = fileData.name

      this.newForum.files.push({
        file: fileData, 
        filename: filename
      })
    },
    removeFile(index) {
      this.newForum.files.splice(index, 1)
    },
    goToClassForum() {
      this.$router.push('/class/' + this.section.id + '/forum')
    }, 
    goToForum() {
      this.$router.push('/forum')
    }
  }
}
</script>

<style>
.hidden-input {
  width: 1px;
  opacity: 0;
}

.forum-container {
  padding: 27px;
}

.forum-content {
  padding: 24px 23.8px 43.5px 25.8px;
  background-color: #ffffff;
}

.forum_p {
  font-size: 12px;
}

#add-modal .modal-dialog {
  max-width: 936px;
}
</style>
